export const uxDesignerTeamDirectory = {
  contacts: [
    'Design Team Lead',
    'UX Researchers', 
    'Product Designers',
    'Frontend Developers',
    'Product Managers'
  ],
  mentors: {
    junior: ['Senior UX Designer', 'Design Team Lead'],
    mid: ['Principal Designer', 'Design Director'],
    senior: ['Design Director', 'VP of Design']
  },
  collaborators: [
    'Product Team',
    'Engineering Team', 
    'Research Team',
    'Content Team'
  ],
  channels: {
    team: '#design-team',
    general: '#design-general',
    critique: '#design-critique',
    resources: '#design-resources'
  }
};
